import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 18v-12","key":"svg-0"}],["path",{"d":"M13 6l4 4l4 -4","key":"svg-1"}],["path",{"d":"M11 18l-7 -8l4 -4l4 4l-7 8","key":"svg-2"}]]

/**
 * IconAlphabetRunes
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWxwaGFiZXQtcnVuZXMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDE4di0xMiIgLz4KICA8cGF0aCBkPSJNMTMgNmw0IDRsNCAtNCIgLz4KICA8cGF0aCBkPSJNMTEgMThsLTcgLThsNCAtNGw0IDRsLTcgOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/alphabet-runes
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAlphabetRunes = createReactComponent('outline', 'alphabet-runes', 'AlphabetRunes', __iconNode);

export default IconAlphabetRunes;